export enum VisibleAngle {
    Front = 'Front',
    FrontLeft = 'FrontLeft',
    FrontRight = 'FrontRight',
    Left = 'Left',
    Right = 'Right',
    Back = 'Back',
    BackLeft = 'BackLeft',
    BackRight = 'BackRight',
}
